







































































import { BaseCont, CONT_IDS } from "@/models/continuity/BaseCont";
import StuntSheet from "@/models/StuntSheet";
import Vue from "vue";
import ContEditorHelper from "./ContEditorHelper.vue";
import Dot from "@/components/grapher/Dot.vue";
import DotAppearanceModal from "./DotAppearanceModal.vue";
import { Mutations } from "@/store/mutations";

/**
 * View/Edit all continuiuties for a dot type
 */
export default Vue.extend({
  name: "DotTypeEditor",
  data: () => ({
    dotAppearanceModalActive: false,
  }),
  components: {
    ContEditorHelper,
    Dot,
    DotAppearanceModal,
  },
  props: {
    dotTypeIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dotType(): BaseCont[] {
      const selectedSS = this.$store.getters
        .getSelectedStuntSheet as StuntSheet;
      return selectedSS.dotTypes[this.dotTypeIndex];
    },
  },
  methods: {
    addContInPlace() {
      this.$store.commit(Mutations.ADD_CONTINUITY, {
        dotTypeIndex: this.dotTypeIndex,
        contID: CONT_IDS.IN_PLACE,
      });
    },
    addContETFDynamic() {
      this.$store.commit(Mutations.ADD_CONTINUITY, {
        dotTypeIndex: this.dotTypeIndex,
        contID: CONT_IDS.ETF_DYNAMIC,
      });
    },
    addContETFStatic() {
      this.$store.commit(Mutations.ADD_CONTINUITY, {
        dotTypeIndex: this.dotTypeIndex,
        contID: CONT_IDS.ETF_STATIC,
      });
    },
    addContEven() {
      this.$store.commit(Mutations.ADD_CONTINUITY, {
        dotTypeIndex: this.dotTypeIndex,
        contID: CONT_IDS.EVEN,
      });
    },
    addContGateTurn() {
      this.$store.commit(Mutations.ADD_CONTINUITY, {
        dotTypeIndex: this.dotTypeIndex,
        contID: CONT_IDS.GATE_TURN,
      });
    },
  },
});
